import { Timer } from "eventemitter3-timer";

export default class OTicker {
  constructor(stopTime = 1) {
    this._timer = new Timer(stopTime * 1000.0);
    this._isDestroyed = false;
    this._removeOnEnd = true;
    this._timer.on("end", this._onEndHandler, this);
    this._timer.on("repeat", this._onEndRepeatHandler, this);
    this._isHasRepeatCallback = false;
  }

  /** @public */
  start() {
    if (this._isDestroyed) return null;
    if (!this.isStarted) this._timer.start();
    return this;
  }

  /** @public */
  stop() {
    if (this._isDestroyed) return null;
    if (this.isStarted) this._timer.stop();
    return this;
  }

  /** @public */
  reset() {
    if (this._isDestroyed) return null;
    this._timer.reset();
  }

  /**     * @public     */
  destroy() {
    if (!this._isDestroyed) {
      if (!this.isEnded) this._timer.stop();
      this._isDestroyed = true;
      this._timer.remove();
      this._timer.timerManager = null;
      this._timer.removeAllListeners("end");
      this._timer.removeAllListeners("start");
      this._timer.removeAllListeners("repeat");
      this._timer.removeAllListeners("stop");
      this._timer = null;

      this._onComplete = null;
      this._context = null;
      this._params = null;
    }

    return this;
  }

  /**     * @public     */
  on(fnc, c, params = []) {
    if (this._isDestroyed) return null;
    this._onComplete = fnc;
    this._context = c;
    this._params = params;
    params.push(this);
  }

  /** @public */
  onStart(fnc, c, once = false) {
    if (once)
      this._timer.once("start", fnc, c);
    else
      this._timer.on("start", fnc, c);

  }

  /** @public */
  onEnd(fnc, c, once = false) {
    if (once)
      this._timer.once("end", fnc, c);
    else
      this._timer.on("end", fnc, c);

  }

  /** @public */
  onRepeat(fnc, c, once = false) {
    if (once)
      this._timer.once("repeat", fnc, c);
    else
      this._timer.on("repeat", fnc, c);
    this._isHasRepeatCallback = true;
  }

  /** @public */
  onStop(fnc, c, once = false) {
    if (once)
      this._timer.once("stop", fnc, c);
    else
      this._timer.on("stop", fnc, c);
  }

  /** @public */
  onUpdate(fnc, c) {
    this._timer.on("update", fnc, c);
  }

  /** @public */
  offStart(fnc, c) {
    this._timer.off("start", fnc, c);
  }

  /** @public */
  offEnd(fnc, c) {
    this._timer.off("end", fnc, c);
  }

  /** @public */
  offRepeat(fnc, c) {
    this._timer.off("repeat", fnc, c);
    if (this._timer.listenerCount("repeat") <= 1) this._isHasRepeatCallback = false;
  }

  /** @public */
  offStop(fnc, c) {
    this._timer.off("stop", fnc, c);
  }

  /** @public */
  offUpdate(fnc, c) {
    this._timer.off("update", fnc, c);
  }

    forceEndCall() {
        this._onEndHandler();
    }

  /** @private */
  _onEndHandler(elapsed) {
    if (this._isDestroyed) return null;
    if (this._onComplete)
      this._onComplete.apply(this._context, this._params);
    if (this._removeOnEnd)
      this.destroy();
  }

  /**     * @private     */
  _onEndRepeatHandler(elapsed) {
    !this._isHasRepeatCallback && this._onComplete?.apply(this._context, this._params);
  }

  set time(value) {
    this._timer.time = value * 1000.0;
  }

  get time() {
    return this._timer.time * 1000.0;
  }

  get active() {
    return this._timer.active;
  }

  get isStarted() {
    return this._timer.isStarted;
  }

  get isEnded() {
    return this._timer.isEnded;
  }

  set expire(value) {
    this._removeOnEnd = value;
  }

  get expire() {
    return this._removeOnEnd;
  }

  set delay(value) {
    this._timer.delay = value * 1000.0;
  }

  get delay() {
    return this._timer.delay * 1000.0;
  }

  set repeat(value) {
    if (value < 1) value = 0;
    value--;
    this._timer.repeat = value;
  }

  get repeat() {
    return this._timer.repeat;
  }

  set loop(value) {
    this._timer.loop = value;
  }

  get loop() {
    return this._timer.loop;
  }

  get completeParams() {
    return this._params;
  }
}
